module.exports = __webpack_public_path__ + "img/carp_3kl.500c6f64.jpg";